// 系统配置入口
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui'
import store from './vuex/store'
import Vuex from 'vuex'
import router from '@/base/router'
// 路由权限校验
import './permission'
// 样式文件需要单独进行引入
import 'element-ui/lib/theme-chalk/index.css'

// 引入icon
import './assets/icon/iconfont.css'
// 引入common.js
import '../static/style/common.less'
// 引入echarts
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
import china from 'echarts/map/json/china.json'

echarts.registerMap('china', china)
// highCharts的全局设置，中文
import Highcharts from 'highcharts'

Highcharts.setOptions({
  // options here
  lang: {
    contextButtonTitle: '图表导出菜单',
    decimalPoint: '.',
    downloadJPEG: '下载JPEG图片',
    downloadPDF: '下载PDF文件',
    downloadPNG: '下载PNG文件',
    downloadSVG: '下载SVG文件',
    drillUpText: '返回 {series.name}',
    loading: '加载中',
    months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    noData: '没有数据',
    numericSymbols: ['千', '兆', 'G', 'T', 'P', 'E'],
    printChart: '打印图表',
    resetZoom: '恢复缩放',
    resetZoomTitle: '恢复图表',
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    thousandsSep: ',',
    weekdays: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天']
  }
})
// 引入百度地图
import BaiduMap from 'vue-baidu-map'
// 按钮权限校验方法
import checkPermission, {hasAllPermission} from '@/common/permission'

import AFTableColumn from "af-table-column"
Vue.use(AFTableColumn)

Vue.prototype.checkPermission = checkPermission
Vue.prototype.hasAllPermission = hasAllPermission

// 模拟测试
// import Mock from './mock'
// 阻止vue在启动时生成生产提示
Vue.config.productionTip = false

// Vue.config.devtools = true

// 在全局Vue中进行使用
Vue.use(VueRouter)
Vue.use(ElementUI)
// 百度地图
Vue.use(BaiduMap, {ak: 'apVgGeyuozEHouxjbG0jMATum0QuUQpE'})
Vue.use(Vuex)
// Mock.init()


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: {
    // 空的实例放到根组件下，所有的子组件都能调用
    Bus: new Vue()
  },
  // components: { App },
  // template: '<App/>'
  render: c => c(App)
})



// WEBPACK FOOTER //
// ./src/main.js